import { useTranslation } from 'react-i18next'
import { TableCell, TableHead, TableRow } from '@mui/material'

export const TableHeader = () => {
  const { t } = useTranslation()

  return (
    <TableHead>
      <TableRow>
        <TableCell>{t('commandParameters.table.headers.parameter')}</TableCell>
        <TableCell>{t('commandParameters.table.headers.type')}</TableCell>
        <TableCell>{t('commandParameters.table.headers.value')}</TableCell>
        <TableCell>{t('commandParameters.table.headers.valueType')}</TableCell>
        <TableCell>{t('commandParameters.table.headers.default')}</TableCell>
        <TableCell align='center' sx={{ width: 40 }} />
      </TableRow>
    </TableHead>
  )
}
